<template>
    <md-toolbar md-elevation="0"
                class="md-transparent"
                :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }">
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
<!--                <h3 class="md-title">{{$t($route.name)}}</h3>-->
            </div>
            <div class="md-toolbar-section-end">
                <md-button class="md-just-icon md-round md-simple md-toolbar-toggle"
                           :class="{ toggled: $sidebar.showSidebar }"
                           @click="toggleSidebar">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>
              
              <warehouse-config-selector :logout="logout"></warehouse-config-selector>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
import {mapGetters} from 'vuex';
import store from '../../../store'
import StorageService from "../../../services/StorageService";
import AccountSelector from "@/pages/Dashboard/Layout/AccountSelector";
import WarehouseConfigSelector from "@/pages/Dashboard/Layout/WarehouseConfigSelector";

export default {
        data() {
            return {

            };
        },
        components: {
          WarehouseConfigSelector,
          AccountSelector
        },
        computed: {
            ...mapGetters(["user"]),
          warehouseId: {
            set(value) {
              if (!value)
                return;

              this.$route.params.accountId = value;
              this.$router.push({name : this.$route.name, params : this.$route.params});
              // store.commit("SET_ACCOUNT", this.user.roles.filter(r => r.mys_account == value)[0]);
            },
            get() {
              return "";
              if (!store.getters.activeWarehouse)
                return null;

              return store.getters.activeWarehouse;
            }
          },
            activeAccountId: {
                set(value) {
                    if (!value)
                        return;

                    this.$route.params.accountId = value;
                    this.$router.push({name : this.$route.name, params : this.$route.params});
                    store.commit("SET_ACCOUNT", this.user.roles.filter(r => r.mys_account == value)[0]);
                },
                get() {
                    if (!store.getters.activeAccount)
                        return null;

                    return store.getters.activeAccount.mys_account;
                }
            }
        },
        methods: {
            logout(){
                store.commit("SET_TOKEN",null);
                StorageService.removeItem("mys_token");
                document.location = "/#/login";
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            minimizeSidebar() {
                if (this.$sidebar) {
                    this.$sidebar.toggleMinimize();
                }
            }
        }
    };
</script>
